import RouterViewPage from '@/views/RouterViewPage.vue';
import md from '@/routes/middlewares';
import PricingManagement from '@/views/admin/aquassistBilling/PricingManagement.vue';
import BillingRegister from '@/views/admin/aquassistBilling/BillingRegister.vue';

const aquassistBilling = {
    path: 'aquassistBilling',
    component: RouterViewPage,
    meta: {
        middlewares: [
            md.isFinancialAdmin,
        ],
    },
    children: [
        // pricing Management section
        {
            path: 'pricingManagement',
            name: 'pricingManagement',
            component: PricingManagement,
        },
        // billing register section
        {
            path: 'billingRegister',
            name: 'billingRegister',
            component: BillingRegister,
        },
    ],
};

export default aquassistBilling;
